export default __webpack_public_path__ + "static/media/onboarding-filters.1cb71792.gif";